import { QAPair } from './interfaces';

export const getQAPairs = async (): Promise<QAPair[]> => {
  return (
    await fetch(process.env.REACT_APP_STRAPI_URL + 'q-and-a-pairs')
  ).json();
};
